import { FC, useEffect, useMemo, useRef } from 'react';
import { useScopedAtom, useScopedAtomValue } from '@lemon8/web-app-shared/ssr';
import { PostDetailModalAtoms } from '../../atoms';

import './style.scss';

export const PartialArticleContent: FC = () => {
  const [folded, setFolded] = useScopedAtom(PostDetailModalAtoms.$CurrentArticleFold);
  const [computed, setComputed] = useScopedAtom(PostDetailModalAtoms.$CurrentArticleHeightComputed);
  const partialArticleRef = useRef<HTMLDivElement>(null);
  const article = useScopedAtomValue(PostDetailModalAtoms.$CurrentArticle);

  const { groupId, shortContent = '' } = article;

  const formattedShortContent = useMemo(() => {
    return shortContent.replace(/&(lt|gt|nbsp|amp|quot);/gi, '').replace(/\s+/g, ' ');
  }, [shortContent]);

  useEffect(() => {
    if (partialArticleRef.current) {
      const { lineHeight: lineHeightInStr } = window.getComputedStyle(partialArticleRef.current);
      const { scrollHeight } = partialArticleRef.current;
      const lineHeight = parseFloat(lineHeightInStr);
      const lineCount = Math.round(scrollHeight / lineHeight);
      if (lineCount <= 3) {
        setFolded(false);
      }
      setComputed(true);
    }
  }, [groupId]);

  return (
    <div
      className="partial-article-content"
      ref={partialArticleRef}
      style={{
        display: folded ? void 0 : 'none',
        visibility: folded && computed ? 'visible' : 'hidden',
      }}
    >
      {formattedShortContent}
    </div>
  );
};
